export default __webpack_public_path__ + "static/media/Tlogo.8804d9b5.png";